import { useTranslation, I18nextProvider } from "react-i18next";
import { FeedbackProvider, HawkinsProvider } from "@hawkins/components";
import { RouterProvider } from "react-router-dom";
import '@hawkins/components/lib/css/allHawkinsStyles.css'

import "./App.css"
import i18n from "./config/i18n";
import { TemporaryRequestProvider } from "./hooks/useTemporaryTicket";
import { SessionProvider } from "./hooks/useSessionContext";
import { LoadingOverlay } from "./components/LoadingOverlay";
import { AppRoutes, ErrorRoute, MaintenanceRoute } from "./routes/AppRoutes";
import { TranslationNamespace } from "./types";
import { useRTL } from './hooks/useRTL';
import useMaintenanceStatus from "./hooks/useMaintenanceStatus";


function AppInitializer() {
  useRTL();
  const { ready } = useTranslation(TranslationNamespace.LEP);

  const { maintenanceMode, loading, error } = useMaintenanceStatus();

  if (!ready || loading) {
    return <LoadingOverlay />;
  }

  if (error) {
    return <RouterProvider router={ErrorRoute} />;
  }

  if (maintenanceMode) {
    return <RouterProvider router={MaintenanceRoute} />;
  }

  return <RouterProvider router={AppRoutes} />;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <TemporaryRequestProvider>
        <HawkinsProvider>
          <SessionProvider>
            <FeedbackProvider
              autoHideDuration={5000}
              maxSnack={3}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
              <AppInitializer />
            </FeedbackProvider>
          </SessionProvider>
        </HawkinsProvider>
      </TemporaryRequestProvider>
    </I18nextProvider>
  );
}

export default App;
